export const omittedFieldsForSaveMaestro = [
  'id',
  'flatten',
  'createdAt',
  'updatedAt',
  'estado',
  'deletedAt',
  'model_id',
  'brand_id',
  // 'branch_office_id',
  '_brand',
  '_model',
  '_version',
  '_segmento',
  'prices',
  'tags',
  'Stocks',
  // TODO: descomentar cuando los colores se manejen de otra manera
  // 'colors',
  '_changed',
]

export const omittedFieldsForSaveProducto = [
  'id',
  'flatten',
  'createdAt',
  'updatedAt',
  // 'CODIA',
  'estado',
  'deletedAt',
  'model_id',
  'brand_id',
  // 'branch_office_id',
  'prices',
  'tags',
  'Stocks',
  '_changed',
]

export const omittedFieldsForSaveStock = [
  //'id',
  'flatten',
  'createdAt',
  'updatedAt',
  // 'CODIA',
  'deletedAt',
  'model_id',
  'brand_id',
  // 'branch_office_id',
  'prices',
  'tags',
  'Stocks',
  '_changed',
  '_loaded'
]

export const omittedFieldsForProgress = [
  ...omittedFieldsForSaveMaestro,
  ...omittedFieldsForSaveProducto,
  ...omittedFieldsForSaveStock
]